import { render, staticRenderFns } from "./PostFeed.vue?vue&type=template&id=eb33c79a&scoped=true&"
import script from "./PostFeed.vue?vue&type=script&lang=js&"
export * from "./PostFeed.vue?vue&type=script&lang=js&"
import style0 from "./PostFeed.vue?vue&type=style&index=0&id=eb33c79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb33c79a",
  null
  
)

export default component.exports